module.exports = __webpack_public_path__ + "static/media/DSC_0235.81c7acd5.JPG";